export default ['products', 'selectedProduct', 'loading', 'originators', 'menuOnMobile'];
